module.exports = __webpack_public_path__ + "img/coin6.140ad8cf.png";